import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CertificationDisplay from '../components/CertificationDisplay';
import logo from '../assets/forgepass logo.png'; // ✅ Path to your logo
import '../App.css';

function Home() {
  console.log("🏠 Home component loaded");

  const [walletAddress, setWalletAddress] = useState('');
  const [loginType, setLoginType] = useState('');
  const navigate = useNavigate();

  const handleLoginSelect = (type) => {
    console.log(`🔐 Login type selected: ${type}`);
    setLoginType(type);
  };

  const connectWallet = async () => {
    try {
      if (!window.ethereum) {
        alert('Please install MetaMask to use this app.');
        console.warn("🦊 MetaMask not found");
        return;
      }

      const [address] = await window.ethereum.request({ method: 'eth_requestAccounts' });
      console.log(`🔗 Wallet connected: ${address}`);
      setWalletAddress(address);

      window.localStorage.setItem('connectedWallet', address);

      if (loginType === 'user') {
        console.log("➡️ Navigating to /user-dashboard");
        navigate('/user-dashboard');
      } else if (loginType === 'company') {
        console.log("➡️ Navigating to /company-dashboard");
        navigate('/company-dashboard');
      } else if (loginType === 'admin') {
        console.log("➡️ Navigating to /admin");
        navigate('/admin');
      }
    } catch (err) {
      console.error('❌ Wallet connection failed:', err);
    }
  };

  const disconnectWallet = () => {
    console.log("🔌 Wallet disconnected");
    setWalletAddress('');
    setLoginType('');
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <img src={logo} alt="ForgePass Logo" className="logo-image" />
        <h2>ForgePass Login</h2>

        {!loginType ? (
          <>
            <p>Select your login type:</p>
            <div className="button-group">
              <button className="login-type-btn" onClick={() => handleLoginSelect('user')}>User</button>
              <button className="login-type-btn" onClick={() => handleLoginSelect('company')}>Company</button>
              <button className="login-type-btn" onClick={() => handleLoginSelect('admin')}>Admin</button>
            </div>
          </>
        ) : !walletAddress ? (
          <>
            <p>Login type: <strong>{loginType}</strong></p>
            <button className="login-type-btn" onClick={connectWallet}>Connect Wallet</button>
          </>
        ) : (
          <>
            <p>Connected Wallet: <code>{walletAddress}</code></p>
            <button className="login-type-btn" onClick={disconnectWallet}>Disconnect</button>
            <CertificationDisplay walletAddress={walletAddress} />
          </>
        )}
      </div>
    </div>
  );
}

export default Home;





